document.addEventListener("DOMContentLoaded", () => {
    const hamburgerMenuBtn = document.querySelector(".hamburger-menu-btn");
    const fullscreenMenu = document.querySelector(".fullscreen-menu");
    const navbar = document.querySelector(".nav-menu");
    const searchBoxBtn = document.querySelector(".searchBoxMobile");
    const searchMenu = document.querySelector(".search-menu");
    const body = document.querySelector("body");
    // const menuIcon = document.querySelector(".menu");
    // const closeIcon = document.querySelector(".close");

    //controls the state of the menu icon
    hamburgerMenuBtn.addEventListener('click', () => {
        if(searchMenu.classList.contains("active")) {
            searchMenu.classList.toggle("active");
            body.classList.remove("overflow-hidden");
        }
        fullscreenMenu.classList.toggle("active")
        hamburgerMenuBtn.classList.toggle("active");
        body.classList.toggle("overflow-hidden");
    });

    //controls the state of the search icon
    searchBoxBtn.addEventListener('click', () => {
        if(fullscreenMenu.classList.contains("active")) {
            fullscreenMenu.classList.toggle("active");
            hamburgerMenuBtn.classList.toggle("active");
        }
        searchMenu.classList.toggle("active");
    });

    const searchDropdown = document.querySelector(".search-dropdown");
    const searchBtn = document.querySelector(".searchBox.dropdown-toggle");
    searchBtn.addEventListener('click', () => {
        searchDropdown.classList.toggle("active");
    });

    // control anchor jump in mobile
    fullscreenMenu.addEventListener('click', (event) => {
        const target = event.target.closest('a');

        if (target) {
            fullscreenMenu.classList.toggle("active")
            hamburgerMenuBtn.classList.toggle("active");
            body.classList.toggle("overflow-hidden");
        }
    });
    
    // navbar remove hover effect on click 
    document.querySelector('.navbar').addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (link && link.closest('.dropdown')) {
            const dropdownMenu = link.closest('.dropdown').querySelector('.dropdown-menu');
            if (dropdownMenu) {
                dropdownMenu.classList.add('no-hover');
                setTimeout(() => {
                    dropdownMenu.classList.remove('no-hover');
                }, 1);
            }
        }
    });
    
})
